export default {
  path: '/job',
  name: 'job',
  redirect: { name: 'job.feed-page' },
  component: () => import(/* webpackChunkName: "job" */ '@/views/job'),
  children: [
    {
      path: '/dashboard',
      name: 'job.feed-page',
      component: () =>
        import(/* webpackChunkName: "feed-page" */ '@/views/job/FeedPage.vue')
    },
    {
      path: '/create-job',
      name: 'job.create-job-page',
      component: () =>
        import(/* webpackChunkName: "create-job-page" */ '@/views/job/CreateJobPage.vue')
    },
    {
      path: '/my-jobs',
      name: 'job.my-jobs-page',
      component: () =>
        import(/* webpackChunkName: "my-jobs-page" */ '@/views/job/MyJobsPage.vue')
    },
    {
      path: '/saved-jobs',
      name: 'job.saved-jobs-page',
      component: () =>
        import(/* webpackChunkName: "saved-jobs-page" */ '@/views/job/SavedJobsPage.vue')
    },
    {
      path: '/jobs/:id/:title',
      name: 'job.view-job-page',
      component: () =>
        import(/* webpackChunkName: "view-job-page" */ '@/views/job/ViewJobPage.vue')
    },
    {
      path: '/jobs/:id/:title/edit',
      name: 'job.edit-job-page',
      component: () =>
        import(/* webpackChunkName: "edit-job-page" */ '@/views/job/EditJobPage.vue')
    }
  ]
}
